/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'toy-brick-plus-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 6V5a2 2 0 00-2-2h-2a2 2 0 00-2 2v1h-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v1H3v14h11v-2H5V8h14v5h2V6m0 9v3h3v2h-3v3h-2v-3h-3v-2h3v-3z"/>'
  }
})
